<template>
    <a :href="url" class="btn btn-sm" rel="external">
                <span class="fa-layers fa-fw">
                    <i class="fas fa-circle fa-lg"></i>
                    <i :class="iconClass" data-fa-transform="right-4"></i>
                </span>
    </a>
</template>
<script type="text/babel">
    export default {
        name: 'SocialMediaButton',
        props: {
            url: {required: true},
            icon: {required: true},
            faType: {default: 'b'}
        },
        computed: {
            iconClass() {
                return `fa-inverse fa${this.faType} fa-${this.icon}`;
            }
        }
    }
</script>
